import makeStyles from '@mui/styles/makeStyles';
import { spacing } from 'studio/helpers';

export default theme => ({
  root: {
    width: 600,
    '& .MuiFormControl-root': {
      marginTop: 0,
      marginBottom: theme.spacing(2)
    }
  },
  actions: {
    marginTop: theme.spacing(4),
    '& .MuiButton-root:first-child': {
      marginRight: theme.spacing(2)
    }
  },
  right: {
    float: 'right',
    marginLeft: 15,
    '& button': {
      marginLeft: 10
    }
  },
  dropzone: {
    marginBottom: 20
  },
  instructions: {
    marginTop: 25,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.6)',
    fontWeight: 300,
    ul: {
      listStyleType: 'circle',
      padding: '0 15px',
      li: {
        margin: '5px 0'
      }
    }
  },
  buttons: {
    marginTop: 20
  },
  fieldContainer: {
    display: 'flex'
  },
  name: {
    width: 400,
    float: 'left'
  },
  language: {
    width: 200 - spacing(theme, 3),
    float: 'right'
  },
  llmDataAccess: {
    clear: 'both',
    marginBottom: 20
  },
  host: {
    width: 400,
    float: 'left'
  },
  port: {
    width: 200 - spacing(theme, 3),
    float: 'right'
  },
  ssh: {
    marginTop: theme.spacing(2)
  },
  instructionsConnector: {
    clear: 'both',
    marginTop: 20,
    paddingTop: 5,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.6)',
    fontWeight: 300,
    '& ul': {
      listStyleType: 'circle',
      padding: '0 15px',
      '& li': {
        margin: '5px 0'
      }
    }
  },
  ipAddress: {
    display: 'inline-flex',
    marginLeft: theme.spacing(1)
  },
  tooltip: {
    maxWidth: 'none',
    fontSize: 12,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5)
  }
});

export const useCopyIconDetails = makeStyles(theme => ({
  root: {
    fill: theme.palette.primary.main,
    cursor: 'pointer'
  }
}));
